import { render, staticRenderFns } from "./NavigationBreadcrumbItem.vue?vue&type=template&id=5c66a293&"
import script from "./NavigationBreadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./NavigationBreadcrumbItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBreadcrumbItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports